const DURATION = 900
const EASING = "cubic-bezier(0.22, 1, 0.36, 1)"
const KEYFRAMES = [
  { clipPath: "inset(-4px 100% -4px -4px)" },
  { clipPath: "inset(-4px -4px -4px -4px)" },
]

export function createReveal() {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return null
  return { startedAt: null }
}

// Redraws share one reveal, so a redraw mid-reveal (e.g. a scrollbar appearing) resumes it instead of cutting it.
export function reveal(node, state) {
  if (!state) return

  const now = document.timeline.currentTime
  state.startedAt ??= now
  const elapsed = now - state.startedAt
  if (elapsed >= DURATION) return

  node.animate(KEYFRAMES, { duration: DURATION, easing: EASING }).currentTime = elapsed
}
